module.exports = __webpack_public_path__ + "static/media/02_New-Haven.c94a6b65.gif";